import React from 'react';
import styled from 'styled-components';

import Icon from './Icon';
import { useNotification } from '../context/notificationContext';

const NotificationItem = ({ id, message, type }) => {
  const { removeNotification } = useNotification();

  return (
    <NotificationItemContainer type={type}>
      {type === 'alert' && (
        <IconContainer>
          <Icon iconName='faExclamationCircle' />
        </IconContainer>
      )}
      {type === 'success' && (
        <IconContainer>
          <Icon iconName='faCheckCircle' />
        </IconContainer>
      )}
      {type === 'info' && (
        <IconContainer>
          <Icon iconName='faInfoCircle' />
        </IconContainer>
      )}
      <MessageContainer>{message}</MessageContainer>
      {(type === 'alert' || type === 'info' || type === 'success') && (
        <CloseContainer onClick={() => removeNotification(id)}>
          <Icon iconName='faTimes' />
        </CloseContainer>
      )}
    </NotificationItemContainer>
  );
};

export default NotificationItem;

const NotificationItemContainer = styled.div`
  display: flex;
  align-items: center;
  color: ${props =>
    props.type === 'alert'
      ? '#721c24'
      : props.type === 'success'
      ? '#3c763d'
      : props.type === 'info'
      ? '#fc8e49'
      : 'inherit'};
  background-color: ${props =>
    props.type === 'alert'
      ? '#f8d7da'
      : props.type === 'success'
      ? '#dff0d8'
      : props.type === 'info'
      ? '#fbe9dd'
      : '#fff'};
  border: ${props =>
    props.type === 'alert'
      ? '#f5c6cb'
      : props.type === 'success'
      ? '1px solid #d6e9c6'
      : props.type === 'info'
      ? '1px solid #f4b892'
      : '1px solid #dedede'};
  margin: 0.5rem;
  width: 30rem;
  box-shadow: 0 0.2rem 0.4rem 0 rgba(0, 0, 0, 0.3);
`;

const IconContainer = styled.div`
  font-size: 1.6rem;
  margin-left: 1.5rem;
`;

const MessageContainer = styled.div`
  flex: 1;
  font-size: 1rem;
  padding: 1rem 0.5rem;
  /* The report errors list the partners that failed one per line; without this
     the list runs together into one paragraph. */
  white-space: pre-line;
`;

const CloseContainer = styled.div`
  margin-right: 0.5rem;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }
`;
